import {
  InformedPickerField,
  InformedTextField
} from '@nw/design-system/omega';

import {
  CATEGORY_OPTIONS,
  CATEGORY_OTHER_VALUE,
  RELIGION_OPTIONS,
  RELIGION_OTHER_VALUE
} from '../../constants/ReligionAndCategoryConstants';

import { FieldContainer } from '../ApplicationSectionsPage/styledComponents';
import { TakeAdmissionInlineFieldsRow } from '../ProductFeeSectionCommonComponents/styledComponents';

const religionAndCategoryFieldCss = `
  max-width: 50%;
  box-sizing: border-box;

  @media (max-width: 769px) {
    max-width: 100%;
  }
`;

interface ReligionAndCategoryProps {
  formProps: any;
  validationSchemaObject: any;
  religionField?: string;
  categoryField?: string;
  specifyReligionField?: string;
  specifyCategoryField?: string;
}

const ReligionAndCategory = ({
  formProps,
  validationSchemaObject,
  religionField = 'religion',
  categoryField = 'category',
  specifyReligionField = 'otherReligion',
  specifyCategoryField = 'otherCategory'
}: ReligionAndCategoryProps) => {
  const { formState } = formProps;
  const { values, errors, touched } = formState as any;

  const religion = String(values?.[religionField] ?? '');
  const category = String(values?.[categoryField] ?? '');
  const isReligionOther = religion === RELIGION_OTHER_VALUE;
  const isCategoryOther = category === CATEGORY_OTHER_VALUE;

  return (
    <>
      <TakeAdmissionInlineFieldsRow>
        <FieldContainer css={religionAndCategoryFieldCss}>
          <InformedPickerField
            isDisabled={false}
            isHidden={false}
            field={religionField}
            key={religionField}
            validationSchemaObject={validationSchemaObject}
            label="Religion"
            placeholder="Select Religion"
            options={RELIGION_OPTIONS}
            error={errors[religionField]}
            touched={touched?.[religionField]}
            reRenderObjects={[religion]}
            isMarginBottomZero={true}
            onChangeOption={() => {
              formProps.formApi.setValue(specifyReligionField, '');
            }}
          />
        </FieldContainer>
        {isReligionOther && (
          <FieldContainer css={religionAndCategoryFieldCss}>
            <InformedTextField
              field={specifyReligionField}
              label="Please Specify Religion"
              placeholder="Enter Religion"
              fieldType="text"
              validateOnBlur={true}
              validateOnChange={true}
              validationSchemaObject={validationSchemaObject}
              touched={touched?.[specifyReligionField]}
              error={errors[specifyReligionField]}
              value={values?.[specifyReligionField]}
              shouldShowIcon={false}
              isDisabled={false}
              isMarginBottomZero
            />
          </FieldContainer>
        )}
      </TakeAdmissionInlineFieldsRow>
      <TakeAdmissionInlineFieldsRow>
        <FieldContainer css={religionAndCategoryFieldCss}>
          <InformedPickerField
            isDisabled={false}
            isHidden={false}
            field={categoryField}
            key={categoryField}
            validationSchemaObject={validationSchemaObject}
            label="Category"
            placeholder="Select Category"
            options={CATEGORY_OPTIONS}
            error={errors[categoryField]}
            touched={touched?.[categoryField]}
            reRenderObjects={[category]}
            isMarginBottomZero={true}
            onChangeOption={() => {
              formProps.formApi.setValue(specifyCategoryField, '');
            }}
          />
        </FieldContainer>
        {isCategoryOther && (
          <FieldContainer css={religionAndCategoryFieldCss}>
            <InformedTextField
              field={specifyCategoryField}
              label="Please Specify Category"
              placeholder="Enter Category"
              fieldType="text"
              validateOnBlur={true}
              validateOnChange={true}
              validationSchemaObject={validationSchemaObject}
              touched={touched?.[specifyCategoryField]}
              error={errors[specifyCategoryField]}
              value={values?.[specifyCategoryField]}
              shouldShowIcon={false}
              isDisabled={false}
              isMarginBottomZero
            />
          </FieldContainer>
        )}
      </TakeAdmissionInlineFieldsRow>
    </>
  );
};

export default ReligionAndCategory;
